// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3907":"31d6cfe0","5496":"a3b9c59c","6122":"d60fe03b","8688":"c979e12a","9751":"589adef2"}[chunkId] + ".chunk.css";
};